import { DEFAULT_MAINTENANCE_PARAMS } from 'core/constants/maintenance.constants';
import type { TUpdateMaintenanceParams } from 'core/model/interfaces/maintenance';
import type { IServiceSuccess } from 'core/model/interfaces/service.interface';
import { https } from 'shared/utils/https';
import type {
  TCreateMaintenanceDTO,
  TMaintenanceDTO,
  TMaintenanceListItemDTO,
  TUpdateMaintenanceDTO,
} from './maintenance.dto';

const versions = {
  v1: '/v1',
} as const;
const baseURL = `${versions.v1}/distributors/maintenance` as const;

export const maintenanceData = {
  getMaintenanceList: async (): Promise<Array<TMaintenanceListItemDTO>> => {
    const url = baseURL;

    const response = await https.get<IServiceSuccess<Array<TMaintenanceListItemDTO>>>(url, {
      params: DEFAULT_MAINTENANCE_PARAMS,
    });

    const { data } = response;

    return data.data;
  },
  getMaintenanceById: async (params: Pick<TMaintenanceListItemDTO, 'id'>): Promise<TMaintenanceDTO> => {
    const { id } = params;

    const url = `${baseURL}/${id}`;

    const response = await https.get<TMaintenanceDTO>(url);

    const { data } = response;

    return data;
  },
  createMaintenance: async (maintenance: TCreateMaintenanceDTO): Promise<TMaintenanceListItemDTO['id']> => {
    const url = baseURL;

    const response = await https.post<TMaintenanceListItemDTO['id']>(url, maintenance);

    const { data } = response;

    return data;
  },
  updateMaintenance: async (maintenance: TUpdateMaintenanceDTO, params: TUpdateMaintenanceParams): Promise<void> => {
    const { id } = params;

    const url = `${baseURL}/${id}`;

    const response = await https.patch<void>(url, maintenance);

    const { data } = response;

    return data;
  },
  deleteMaintenance: async (params: Pick<TMaintenanceListItemDTO, 'id'>): Promise<void> => {
    const { id } = params;

    const url = `${baseURL}/${id}`;

    const response = await https.delete<void>(url);

    const { data } = response;

    return data;
  },
};
